import { PAYMENT_ACCOUNT_TYPES } from 'Data/constants.js'

export function getPayorsCount(payors) {
  if (payors.length === 0) return ''

  let payment_account = payors[0].payment_account
  let payor_name
  switch (payment_account.account_type) {
    case PAYMENT_ACCOUNT_TYPES.Person: {
      payor_name =
        payment_account.person_payment_account.payer_person.first_name.toUpperCase()
      break
    }
    case PAYMENT_ACCOUNT_TYPES.Insurance: {
      payor_name =
        payment_account.insurance_payment_account.insurance_company.carrier_name.toUpperCase()
      break
    }
    default: {
      payor_name = ''
      break
    }
  }

  return payors.length === 1
    ? payor_name
    : `${payor_name} +${payors.length - 1}`
}
